/* NIVIA MAISON — barra de progresso dos carrosséis.

   Sem ResizeObserver de propósito: nesta loja ele não entrega callback
   nenhum (nem a notificação inicial do observe()) — ver o comentário em
   nivia-card-swatches.js. Os gatilhos abaixo cobrem os casos reais. */
(function () {
  if (customElements.get('nm-carousel')) return;

  class NmCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nm-carousel__track');
      this.progress = this.querySelector('.nm-carousel__progress');
      this.bar = this.querySelector('.nm-carousel__progress-bar');
      this.marks = Array.prototype.slice.call(this.querySelectorAll('.nm-carousel__marks li'));
      if (!this.track) return;

      this.nav = this.querySelector('.nm-carousel__nav');
      this.prev = this.querySelector('.nm-carousel__arrow--prev');
      this.next = this.querySelector('.nm-carousel__arrow--next');

      this.onUpdate = this.update.bind(this);
      this.track.addEventListener('scroll', this.onUpdate, { passive: true });
      window.addEventListener('resize', this.onUpdate);
      window.addEventListener('load', this.onUpdate);

      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));

      /* As fotos entram depois e mudam a largura rolável. */
      this.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', this.onUpdate, { once: true });
        img.addEventListener('error', this.onUpdate, { once: true });
      }, this);

      this.update();
      requestAnimationFrame(this.onUpdate);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onUpdate);
      window.removeEventListener('load', this.onUpdate);
    }

    /* Rola um slide por clique, medindo o slide real em vez de um valor
       fixo — os breakpoints mudam a largura dele. */
    step(direction) {
      const slide = this.track.querySelector('.nm-carousel__slide');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const amount = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth * 0.6;
      this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    update() {
      const scrollable = this.track.scrollWidth - this.track.clientWidth;

      if (this.progress) {
        // margem de alguns pixels: sub-pixel fazia a barra aparecer à toa
        this.progress.hidden = scrollable <= 8;
      }

      if (this.nav) {
        this.nav.hidden = scrollable <= 8;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
        if (this.next) this.next.disabled = this.track.scrollLeft >= scrollable - 1;
      }

      if (this.bar && scrollable > 0) {
        const visible = this.track.clientWidth / this.track.scrollWidth;
        const ratio = this.track.scrollLeft / scrollable;
        this.bar.style.width = Math.max(visible * 100, 8) + '%';
        this.bar.style.transform = 'translateX(' + (ratio * (100 / Math.max(visible, 0.08) - 100)) + '%)';
      }

      if (this.marks.length) {
        const idx = Math.round((this.track.scrollLeft / Math.max(scrollable, 1)) * (this.marks.length - 1));
        this.marks.forEach((m, i) => m.classList.toggle('is-active', i === idx));
      }

      /* Slide em foco: o mais próximo da borda esquerda do trilho. A
         timeline usa isso para apagar os vizinhos (referência: 20%). */
      const slides = this.track.children;
      if (slides.length) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const w = slides[0].getBoundingClientRect().width + gap;
        const active = Math.round(this.track.scrollLeft / Math.max(w, 1));
        for (let i = 0; i < slides.length; i++) {
          slides[i].classList.toggle('is-active', i === active);
        }
      }
    }
  }

  customElements.define('nm-carousel', NmCarousel);
})();
